import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useBandwidth } from "../context/BandwidthContext";
import "./css/SiteLoader.css";

const NAME = "Akinola Daniel Oshinubi";

export default function SiteLoader() {
  const { lowData } = useBandwidth();
  const [loading, setLoading] = useState(true);

  // Shows only on initial page load / reload — never on in-app navigation.
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), lowData ? 500 : 2000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const animate = !lowData;

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          className="loader"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: animate ? 0.5 : 0.2 }}
        >
          <div className="loader__inner">
            <motion.span
              className="loader__mark"
              initial={animate ? { scale: 0.7, opacity: 0 } : false}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            >
              AO
            </motion.span>

            <h1 className="loader__name" aria-label={NAME}>
              {animate
                ? NAME.split("").map((ch, i) => (
                    <motion.span
                      key={i}
                      aria-hidden="true"
                      initial={{ y: "0.55em", opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ delay: 0.25 + i * 0.028, duration: 0.4 }}
                    >
                      {ch === " " ? " " : ch}
                    </motion.span>
                  ))
                : NAME}
            </h1>

            <span className="loader__role">
              IT Systems Engineer &amp; Software Developer
            </span>

            {animate && (
              <div className="loader__bar">
                <span />
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
